const actions = {
	GET_DATA_PENDING_PRODUCTS: 'GET_DATA_PENDING_PRODUCTS',
	SET_DATA_PENDING_PRODUCTS: 'SET_DATA_PENDING_PRODUCTS',
	GET_DATA_BEGIN: 'GET_DATA_BEGIN_PENDING_PRODUCTS',
	GET_DATA_FINISH: 'GET_DATA_FINISH_PENDING_PRODUCTS',

	getPendingProducts: () => ({
		type: actions.GET_DATA_PENDING_PRODUCTS,
	}),

	setPendingProducts: (data: any) => ({
		type: actions.SET_DATA_PENDING_PRODUCTS,
		data,
	}),

	getDataBegin: () => ({
		type: actions.GET_DATA_BEGIN,
	}),

	getDataFinish: () => ({
		type: actions.GET_DATA_FINISH,
	}),
};

export default actions;